import Poool from './Poool.js';

window.addEventListener('DOMContentLoaded', () => {
  if (document.documentElement.lang !== 'en-UK') {
    new Poool(
      'Ux3eWdmyaRN4vgVq60rsLRVZu0KCWfNGTVyZ0B74H7CQwkQOekXVg43zcoYyd8YM',
      'Maddyness',
      true,
    );
  }
});
